const IMAGE_MIME_TYPES = new Set(['image/jpeg', 'image/jpg', 'image/png']);

function outputMimeType(file) {
  return file.type === 'image/png' ? 'image/png' : 'image/jpeg';
}

function outputExtension(mime) {
  return mime === 'image/png' ? '.png' : '.jpg';
}

function loadImageFromFile(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const image = new Image();
    image.onload = () => {
      URL.revokeObjectURL(url);
      resolve(image);
    };
    image.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Failed to load image for metadata stripping'));
    };
    image.src = url;
  });
}

function canvasToBlob(canvas, mime) {
  return new Promise((resolve) => {
    canvas.toBlob(resolve, mime, mime === 'image/jpeg' ? 0.92 : undefined);
  });
}

async function stripImageMetadata(file) {
  const mime = file.type.toLowerCase();
  if (!IMAGE_MIME_TYPES.has(mime)) {
    return file;
  }

  try {
    const image = await loadImageFromFile(file);
    const canvas = document.createElement('canvas');
    canvas.width = image.naturalWidth;
    canvas.height = image.naturalHeight;

    const context = canvas.getContext('2d');
    if (!context) {
      return file;
    }

    context.drawImage(image, 0, 0);

    const outputMime = outputMimeType(file);
    const blob = await canvasToBlob(canvas, outputMime);
    if (!blob) {
      return file;
    }

    const baseName = file.name.replace(/\.[^.]+$/, '') || 'image';
    return new File([blob], `${baseName}${outputExtension(outputMime)}`, {
      type: outputMime,
      lastModified: Date.now(),
    });
  } catch {
    return file;
  }
}

export { stripImageMetadata };
